export const EMOJI_GROUP = {
  SMILEYS: "smileys",
  GESTURES: "gestures",
} as const;

export type EmojiGroupId = (typeof EMOJI_GROUP)[keyof typeof EMOJI_GROUP];

export type EmojiItem = {
  emoji: string;
  name: string;
  keywords: readonly string[];
  group: EmojiGroupId;
};
